module.exports = __webpack_public_path__ + "static/media/ply-icon.3cfc6c25.png";